import React, { useState, useEffect } from 'react';
import AttestedListMobile from './attestedListMobile';
import AttestedListWeb from './attestedListWeb';

const useWindowWidth = () => {
  const [windowWidth, setWindowWidth] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowWidth;
};

const AttestedListRouter = (props) => {
  const width = useWindowWidth();
  const MOBILE_BREAKPOINT = 768;

  if (width === 0) {
    return null;
  }

  return width < MOBILE_BREAKPOINT ? (
    <AttestedListMobile {...props} />
  ) : (
    <AttestedListWeb {...props} />
  );
};

export default AttestedListRouter;
